import React from 'react'

type ConfigurationCycleItemProps = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  value: string;
  checked: boolean;
  editingController?: string | null;
  updateEditingController?: (serial_number: string) => void;
  viewEditAction: boolean;
}

const ConfigurationCycleItem: React.FC<ConfigurationCycleItemProps> = ({
  onChange,
  name,
  value,
  editingController,
  updateEditingController,
  viewEditAction,
  checked
}) => {
  return (
    <li
      className="с-configuration-cycle-item flex flex-row gap-x-5 justify-between items-center"
      key={name}
    >
      <label htmlFor={name} className="с-configuration-cycle-item__label cursor-pointer truncate">
        <div className="с-configuration-cycle-item__wrapper relative flex items-center pt-0.5">
          <input
            type="checkbox"
            id={name}
            name={name}
            className="с-configuration-cycle-item__input"
            onChange={onChange}
            value={value}
            checked={checked}
          />
          <span className="pl-2 overflow-hidden text-ellipsis">{name}</span>
        </div>
      </label>
      {viewEditAction && (
        <p
          className={`${editingController === value ? 'text-green-400' : ''} cursor-pointer`}
          onClick={() => updateEditingController(value)}
        >
          {editingController === value ? 'Editing' : 'Edit'}
        </p>
      )}
    </li>
  )
};

export default ConfigurationCycleItem;